"use client";

import { useBloomreachPageView } from "@/vendors/Bloomreach/use-bloomreach-page-view-hook";
export function TrackPageView() {
  useBloomreachPageView();
  return null;
}